import { withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { SubmissionService } from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NotesComponent from '../../Components/NotesComponent/NotesComponent';
import gatewayMessages from '../../gateway.messages';
import messages from './Notes.messages';
import metadata from './Notes.metadata.json5';

class QuoteDetailsNotes extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            quoteDetailsData: PropTypes.shape({
                jobNumber: PropTypes.string,
                getQuoteSummaryCount: PropTypes.func,
            }),
            basePath: PropTypes.string,
        }).isRequired,
    };

    state = {
        notesData: [],
        loaded: true,
    };

    componentDidMount() {
        this.getNotes();
    }

    handleError = (title, message) => {
        const { modalContext } = this.props;
        return modalContext
            .showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok,
            })
            .catch(_.noop);
    };

    getNotes = async () => {
        const {
            authHeader,
            fromAccountLanding: {
                quoteDetailsData: { jobNumber, getQuoteSummaryCount },
            },
        } = this.props;
        this.setState({ loaded: false });
        try {
            const getAvailableNotesData =
                await SubmissionService.getNotesForSubmission(
                    [jobNumber],
                    authHeader
                );
            this.setState({
                notesData: getAvailableNotesData,
                loaded: true,
            });
            getQuoteSummaryCount();
        } catch (e) {
            this.handleError(
                gatewayMessages.modalError,
                gatewayMessages.errorLoadingNotes
            );
        }
    };

    createNote = async data => {
        const {
            authHeader,
            fromAccountLanding: {
                quoteDetailsData: { jobNumber },
            },
        } = this.props;
        this.setState({ loaded: false });
        try {
            const quoteDetailsNoteData =
                await SubmissionService.createNoteForSubmission(
                    [jobNumber, data],
                    authHeader
                );
            if (!_.isEmpty(quoteDetailsNoteData)) {
                this.getNotes();
            }
        } catch (e) {
            this.handleError(
                gatewayMessages.modalError,
                gatewayMessages.errorLoadingNotes
            );
        }
    };

    render() {
        const { notesData, loaded } = this.state;
        const translator = this.context;
        const overrides = {
            quoteDetailsNotes: {
                initialNotesData: notesData,
                createNote: this.createNote,
                noDataMessage: translator(messages.noQuoteNotes),
                visible: loaded,
                openActivitiesNote: false,
            },
            notesLoader: {
                loaded: loaded,
            },
        };
        const resolvers = {
            resolveComponentMap: {
                notescomponent: NotesComponent,
            },
        };
        return (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
    }
}

export default withAuthenticationContext(withModalContext(QuoteDetailsNotes));
